import React from 'react';

import styled, { keyframes } from 'styled-components';

import { getHexTransparencyColor } from '@crehana/ui/dist/helpers';
import { white } from '@crehana/ui/dist/styles/colors';

import { CreditCardIssuerType } from 'Jsx/CheckoutV4/types';

import CardBrandIcon from './CardBrandIcon';
import { CreditCardNumberState } from './CreditCardNumberInput';
import { CVCState } from './CVVInput';
import { ExpirationDateState } from './ExpirationDateInput';

export const animationCard = keyframes`
  from {
    transform: rotateY(180deg);
  }
  to {
    transform: rotateY(0deg);
  }
`;

const Card = styled.div`
  background: radial-gradient(
    100% 332.18% at 0% 46.43%,
    #4b22f4 0%,
    #3417aa 51.19%,
    #1d2559 100%
  );
  box-shadow: 0px 12px 32px rgba(75, 34, 244, 0.5);
  border-radius: 20px;
  animation: ${animationCard} 0.6s linear;
`;
const CardCVV = styled.div`
  background: radial-gradient(
    100% 332.18% at 0% 46.43%,
    #4b22f4 0%,
    #3417aa 51.19%,
    #1d2559 100%
  );
  box-shadow: 0px 12px 32px rgba(75, 34, 244, 0.5);
  border-radius: 20px;
  animation: ${animationCard} 0.6s linear;
`;

interface AnimatedCardProps {
  creditCardIssuer?: CreditCardIssuerType;
  creditCardNumber?: CreditCardNumberState;
  creditCardExpiry?: ExpirationDateState;
  creditCardCVV?: CVCState;
}

const AnimatedCard: React.FC<AnimatedCardProps> = ({
  creditCardIssuer,
  creditCardNumber,
  creditCardExpiry,
  creditCardCVV,
}) => {
  const isCVV = creditCardNumber?.isValid && creditCardExpiry?.isValid;

  return isCVV ? (
    <CardCVV className="flex flex-col py-40">
      <p className="mb-16 bg-base-dark h-40" />
      <p className="mx-32 font-body1 text-right h-36  rounded-5 mb-24 flex">
        <span
          className="h-36 w-full inline-block"
          style={{
            background: 'linear-gradient(90deg, #e8eaf0 0%, #ffffff 100%)',
            borderRadius: '5px 0 0 5px',
          }}
        />
        <span
          className="bg-white h-36 pt-4 px-8"
          style={{ borderRadius: '0px 5px 5px 0px' }}
        >
          {creditCardCVV?.cvc || '****'}
        </span>
      </p>
    </CardCVV>
  ) : (
    <Card className="flex flex-col px-24 pt-40 pb-24">
      <p className="mb-80 h-24 flex items-center z">
        {creditCardIssuer ? (
          <CardBrandIcon cardType={creditCardIssuer} />
        ) : (
          <span
            className="w-48 h-32 rounded-5"
            style={{
              background: getHexTransparencyColor(white, 40),
            }}
          />
        )}
      </p>
      <p className="flex justify-between text-white font-body1">
        <span>{creditCardNumber?.number || '**** **** **** ****'}</span>
        <span>{creditCardExpiry?.expiration || 'MM/AA'}</span>
      </p>
    </Card>
  );
};

export default AnimatedCard;
